import { Controller } from '@hotwired/stimulus'

// Hide <table> columns
// Controller is attached to the <table> element with column targets
//
// For ex:
//    <table data-controller="toggle-table-column">
//       <th data-toggle-table-column-target="column" data-column-name="myColumnName">
//         <button data-action="change->toggle-table-column#toggleColumn" data-column-name="myColumnName">
//           Hide Column
//       <td data-toggle-table-column-target="column" data-column-name="myColumnName">
//    Click -> hides both th and td

export default class extends Controller {
    static targets = ['column', 'columnName']
    static outlets = ['show-element']

    connect() {
        this.hideToggleButtonIfLastColumn()
    }

    toggleColumn(event) {
        event.preventDefault()
        const { columnName } = event.currentTarget.dataset
        this.toggleColumnVisibility(columnName)
        this.changed()
        this.hideToggleButtonIfLastColumn()
    }

    toggleColumnVisibility(columnName) {
        // Iterate through all column targets and remove matching ones
        // Each td/th will have a uniqe columnName
        // Using columnName instead of index as it's more robust and easier to deal
        // with reordering
        this.columnTargets.forEach((column) => {
            if (column.dataset.columnName === columnName) {
                column.remove()
            }
        })
    }

    changed() {
        // Render a status notification element (if exists)
        this.showElementOutlets.forEach((showElement) => showElement.show())
    }

    // Table must have at least one column, so dont let user hide all of them
    hideToggleButtonIfLastColumn() {
        const uniqueColumns = new Set(this.columnTargets.map((col) => col.dataset.columnName))
        if (uniqueColumns.size === 1) {
            const button = this.element.querySelector('[aria-label="Hide column"]')
            button.classList.add('d-none')
        }
    }
}
